/**
 * @since 0.1.1
 */
import { z } from 'zod';

/**
 * @category sharedSchema
 * @since 0.1.1
 */
export const string = z.string();

/**
 * @category sharedSchema
 * @since 0.1.1
 */
export const boolean = z.boolean();
